module.exports = __webpack_public_path__ + "static/media/thumbnail_advincula-soft-cup@3x.2f460a01.jpg";